import { client } from './API';

export function mergeUsers({ userId, toUserId }) {
  return client.post(`/api/ownership/transfer-ownership`, {
    fromUsername: userId,
    toUsername: toUserId,
  });
}
